import { HardHat, Landmark, Network, Shield } from "lucide-react";
import { Reveal } from "./Reveal";

const SECTORS = [
  {
    icon: Shield,
    name: "Defence",
    copy: "Supply chain, sustainment and In-Country Value support across Defence programs.",
  },
  {
    icon: Landmark,
    name: "Government",
    copy: "Commercial, procurement and logistics support for Commonwealth and state programs.",
  },
  {
    icon: HardHat,
    name: "Mining",
    copy: "Logistics, inventory and operational support for resources and remote operations.",
  },
  {
    icon: Network,
    name: "Complex Programs",
    copy: "Assurance and problem solving for multi-party, high-stakes programs and projects.",
  },
];

export default function TrackRecord() {
  return (
    <section data-testid="track-record-section" className="py-24 md:py-32 border-t border-white/5">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal>
          <p className="text-xs md:text-sm tracking-[0.25em] uppercase text-teal-400 font-medium">
            Track record
          </p>
          <h2 className="mt-4 font-display text-3xl md:text-5xl tracking-tight leading-tight text-slate-50 max-w-3xl">
            Experience where the stakes are highest.
          </h2>
          <p className="mt-5 max-w-2xl text-base md:text-lg leading-relaxed text-slate-300">
            Four decades across Defence, Government, mining and complex major programs —
            in Australia and overseas.
          </p>
        </Reveal>

        <Reveal delay={0.08}>
          <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
            {SECTORS.map((s) => (
              <div
                key={s.name}
                data-testid={`track-record-${s.name.toLowerCase().replace(/\s+/g, "-")}`}
                className="group bg-[#02060D] p-8 md:p-9 hover:bg-[#07131F] transition-colors duration-500"
              >
                <s.icon className="h-7 w-7 text-teal-400" strokeWidth={1.5} />
                <h3 className="mt-6 font-display text-xl md:text-2xl text-slate-50">{s.name}</h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-400">{s.copy}</p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
